<section class="footer">
    <div class="main-block">
        <div class="footer-block">
                <li><h2>Contact Info</h2></li>
                <br>
                <li>
                    Phone: 021-3564478
                </li>
                <li>
                    Address: DHA Suffa University
                </li>
                <li>
                    Khayaban-e-Tufail Phase 7 ext.
                </li>
        </div>
        <div class="footer-block">
                <li><h2>Get Help</h2></li>
                <br>
                <li><a href="/help/1">How it works</a></li>
                <li><a href="/help/2">Returns & Refunds</a></li>
                <li><a href="/help/3">Security Deposit</a></li> 
        </div>
        <div class="footer-block">
            <li><h2>Popular Categories</h2></li>
                <br>
                <li><a href="/categories/4">Groom</a></li>
                <li><a href="/categories/1">Bridal Dresses</a></li>
                <li><a href="/categories/3">Suits</a></li>
                <li><a href="/categories/2">Casual Ladies Dresses</a></li>
        </div>
        <div class="footer-block">
            <li><h2>Let’s stay in touch</h2></li>
                <br>
                <li>
                    <input  name="email" [(ngModel)]="email" type="text" placeholder="Email">
                    <button (click)="mailingList()">subscribe</button>
                </li>
                <li><p>Keep up to date with our latest <br> news and special offers.</p></li>
                
        </div>
    </div>
    <hr>
    <div class="bottom-bar">
        <p>All Rights Reserved 2021</p>
    </div>
</section>